import { render, staticRenderFns } from "./CustomerHeaderDesktop.vue?vue&type=template&id=3964d630&scoped=true&"
import script from "./CustomerHeaderDesktop.vue?vue&type=script&lang=js&"
export * from "./CustomerHeaderDesktop.vue?vue&type=script&lang=js&"
import style0 from "./CustomerHeaderDesktop.vue?vue&type=style&index=0&id=3964d630&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3964d630",
  null
  
)

export default component.exports
import {QHeader,QToolbar,QTabs,QRouteTab,QTab} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QHeader,QToolbar,QTabs,QRouteTab,QTab})
